import instance from '@/utils/instance';

//获取所有推荐标准
export function getQuerySuggestStandard() {
  return instance({
    url: '/webL_api/essential/api/querySuggestStandard',
    method: 'get',
  })
}
